const data = [
  {
    id: 1,
    title: "NWDC",
    desc: "NWDC (Nightlogin Web Development Community) merupakan komunitas bagi mahasiswa yang memiliki ketertarikan kepada web, baik itu web development maupun web design.",
    to: "/communities/NWDC"
  },
  {
    id: 2,
    title: "NUXC",
    desc: "Komunias NUXC (Night Login User Experience Community) merupakan komunitas bagi mahasiswa yang menyenangi ataupun ingin menggeluti user experience.",
    to: "/communities/NUXC"
  },
  {
    id: 3,
    title: "NADC",
    desc: "Komunias NADC (Night Login Application Development Community) merupakan komunitas bagi mahasiswa yang menyenangi ataupun ingin menggeluti application development.",
    to: "/communities/NADC"
  },
  {
    id: 4,
    title: "NDDC",
    desc: "Komunitas NDDC (Nightlogin Data Science and Data Analytic Community)  merupakan komunitas bagi mahasiswa yang menyenangi ataupun ingin menggeluti data dan analytics.",
    to: "/communities/NDDC"
  },
  {
    id: 5,
    title: "NLNC",
    desc: "NLNC (Nightlogin Linux and Networking Community) merupakan komunitas bagi mahasiswa yang tertarik pada Linux dan Jaringan, seperti keamanan jaringan, dll.",
    to: "/communities/NLNC"
  },
  {
    id: 6,
    title: "NCPC",
    desc: "NCPC (Nightlogin Competitive Programming Community) merupakan komunitas bagi mahasiswa yang memiliki ketertarikan kepada competitive programming.",
    to: "/communities/NCPC"
  },
];

export default data;